export const GUIDED_SUCCESS_URL = 'https://support.omnea.co/articles/9473838665-guided-success'
